import { trans } from '@lingoda/i18n';
import { Alert } from '@lingoda/ui';

export const CaptchaAlert = () => {
    return <Alert severity="error">{getCaptchaErrorMessage()}</Alert>;
};

export const getCaptchaErrorMessage = () => trans('captcha.not_passed', {}, 'validators');
